import { render, staticRenderFns } from "./orgStructure.vue?vue&type=template&id=7f38d56e"
import script from "./orgStructure.vue?vue&type=script&lang=js"
export * from "./orgStructure.vue?vue&type=script&lang=js"
import style0 from "./orgStructure.vue?vue&type=style&index=0&id=7f38d56e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports